import React from 'react';


const WinnerCustInfo = ({name, regno}) => {
  return (
    <div className="flex w-4/5 min-h-[50px] justify-between items-center bg-blue-50 text-[#0987F3] rounded-lg font-bold text-lg px-10 cursor-pointer mobile:px-0 mobile:text-sm mobile:flex-col mobile:h-[50px] mobile:py-2">
        <p>{name}</p>
        <p>{regno}</p>
    </div>
  );
}

export default WinnerCustInfo;